/**
 * Keep only the classes that position or size a field — width, margin, flex —
 * and drop the ones that paint an input (border, radius, background, padding,
 * height, typography, focus ring).
 *
 * Why: DateInput / MonthInput replaced native <input type="date|month"> fields
 * whose callers still pass the old input skin as `className`. DatePicker puts
 * that on its outer wrapper and renders its own bordered input inside, so the
 * legacy skin drew a second border around the real field on every page. The
 * wrappers pass `className` through here so layout survives and the skin
 * doesn't.
 */
const LAYOUT_PREFIXES = [
  'w-',
  'min-w-',
  'max-w-',
  'm-',
  'mx-',
  'my-',
  'mt-',
  'mb-',
  'ml-',
  'mr-',
  'flex-',
  'self-',
  'basis-',
];
const LAYOUT_EXACT = new Set(['flex', 'grow', 'shrink', 'shrink-0', 'grow-0', 'block', 'inline-block', 'inline-flex']);

export function layoutClassesOnly(className?: string): string | undefined {
  if (!className) return undefined;
  const kept = className.split(/\s+/).filter((token) => {
    if (!token) return false;
    // Responsive / state variants: judge the utility after the last colon.
    const utility = token.slice(token.lastIndexOf(':') + 1);
    return LAYOUT_EXACT.has(utility) || LAYOUT_PREFIXES.some((p) => utility.startsWith(p));
  });
  return kept.length ? kept.join(' ') : undefined;
}
